<script setup lang="ts">
import {useCurrentLangStore} from "~/stores/pageLangStore";
import {onMounted, ref, toRaw, watch} from 'vue';
import Spinner from "~/components/Spinner.vue";
import {usePageTitle} from "~/composables/usePageTitle";

const config = useRuntimeConfig();

const route = useRoute();
const currentLangStore = useCurrentLangStore();

function normalizeCourse(course: string | string[]): string {
    if (Array.isArray(course)) {
        course = course[0];
    }

    return course.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

let selectedCourse = normalizeCourse(route.params.course);
let lang = localStorage.getItem("currentLang") || window.navigator.language;
let isRedirecting = ref(false);
let isLoading = ref(true);
let items = ref([]);
const responseData = ref<any>(null);

const fetchData = async () => {
    try {
        isLoading.value = true;
        let {data}: any = await useFetch(
            () => `${config.public.baseUrlBackend}/api/course/geral/${selectedCourse}/${lang}`,
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                },
            }
        );
        if (data.value?.redirect) {
            isRedirecting.value = true;
            return navigateTo(data.value.url, {external: true});
        }
        responseData.value = data.value;
        items.value = toRaw(data.value?.page_sections) || [];
    } finally {
        isLoading.value = false;
    }
};

const updateItems = async () => {
    await fetchData();
};

watch(currentLangStore, async (newVal) => {
    lang = localStorage.getItem("currentLang") ?? newVal.value;
    await updateItems();
});

onMounted(async () => {
    await fetchData();
});

const { pageTitle } = usePageTitle('', responseData);

useHead({
    title: pageTitle,
})
</script>

<template>
    <div class="flex">
        <div class="w-screen h-screen bg-white">
            <CardRedirect v-if="isRedirecting" />

            <div v-else-if="!isLoading && items && items.length">
                <component
                    v-for="item in items"
                    :key="item.id"
                    :is="item.name"
                    :components="item.components"
                    :classes="item.class"
                    :color="item.color"
                />
            </div>

            <Card404 v-else-if="!isLoading && (!items || !items.length)" />

            <Spinner v-else />

            <FooterFull/>
        </div>
    </div>
</template>

<style>
.flex div {
    max-width: 1920px;
}
</style>
